export default __webpack_public_path__ + "static/media/ic-absent.97dd6963.svg";